import { Component } from '@angular/core';

import { MessageService as PrimeMessageService } from 'primeng/api';

import { Alert } from '../../../models/alert.model';
import { MessageService } from '../../../services/message.service';
import { AlertType } from '../../../enumerators/messages.enum';

@Component({
  selector: 'alert-timer',
  templateUrl: './alert-timer.component.html',
  styleUrls: ['./alert-timer.component.scss']
})
export class AlertTimerComponent {
  alert: Alert = new Alert();

  timer: any;
  descripcionBase: string = "";
  finTimer: any;
  abierto: boolean = false;

  constructor(private messageService: MessageService, private primeMessageService: PrimeMessageService) {
  }

  ngOnInit() {
    this.messageService.startTimerAlert().subscribe((alert: Alert) => {
      this.alert = alert;
      this.setAlertData(this.alert);
      this.primeMessageService.clear();
      this.primeMessageService.add({ severity: alert.class, summary: '', detail: alert.description, life: alert.timer, closable: false });
    });
  }

  setAlertData(alert: Alert) {
    switch (alert.type) {
      case AlertType.Success:
        alert.icon = "fa fa-check";
        alert.class = "success"
        break;

      case AlertType.Warning:
        alert.icon = "fa fa-exclamation-triangle";
        alert.class = "warn"
        break;

      case AlertType.Error:
        alert.icon = "fa fa-exclamation-triangle";
        alert.class = "error"
        break;

      case AlertType.Information:
        alert.icon = "fa fa-info";
        alert.class = "info"
        break;

      default:
        break;
    }

  }

  cancelAlert() {
    this.primeMessageService.clear();
  }


}
